/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { DateRange } from "react-date-range";
import {  FaCalendarAlt } from "react-icons/fa";

import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";

const PAGE_SIZE = 10;

const CustomerLedger = () => {
  const [data, setData] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);

  //  Filters
  const [name, setName] = useState("");
const [mobile, setMobile] = useState("");
  const [dateRange, setDateRange] = useState([
    { startDate: null, endDate: null, key: "selection" },
  ]);

  const [showCalendar, setShowCalendar] = useState(false);
  const [tempRange, setTempRange] = useState(dateRange);

  const calendarRef = useRef(null);
const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const res = await axios.get(
      `${API_URL}/api/reports/customer-ledger`
    );

    const sorted = (res.data.data || []).sort(
      (a, b) => new Date(a.Date) - new Date(b.Date)
    );

    setData(sorted);
    setFiltered(sorted);
  };

  //  Close calendar on outside click
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (calendarRef.current && !calendarRef.current.contains(e.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //  FILTER LOGIC
 useEffect(() => {
  const { startDate, endDate } = dateRange[0];

  const end = endDate
    ? new Date(endDate.getTime() + 86400000 - 1)
    : null;

  const result = data.filter((item) => {
    const matchName = item.FullName
      ?.toLowerCase()
      .includes(name.toLowerCase());

    const matchMobile = item.Mobile?.includes(mobile);

    const itemDate = new Date(item.Date);

    const matchDate =
      startDate && endDate
        ? itemDate >= startDate && itemDate <= end
        : true;

    return matchName && matchMobile && matchDate;
  });

  const updated = addRunningBalance(addAutoSettlement(result));
setFiltered(updated);
  setPage(1);
}, [name, mobile, dateRange, data]);

const addAutoSettlement = (data) => {
  //  Remove previously added auto rows
  const cleanData = data.filter(item => item.Type !== "Auto Settlement");

  const result = [...cleanData];
  const map = {};

  cleanData.forEach((item) => {
    if (!map[item.BookingCode]) {
      map[item.BookingCode] = {
        totalDebit: 0,
        totalCredit: 0,
        eventDate: item.EventDate,
        sample: item,
      };
    }

    map[item.BookingCode].totalDebit += item.Debit;
    map[item.BookingCode].totalCredit += item.Credit;
  });

  const today = new Date();

  Object.keys(map).forEach((code) => {
    const b = map[code];
    const remaining = b.totalDebit - b.totalCredit;

    if (today > new Date(b.eventDate) && remaining > 0) {
      result.push({
        ...b.sample,
        Type: "Auto Settlement",
        Debit: 0,
        Credit: remaining,
        Date: new Date(b.eventDate),
      });
    }
  });

  //  Always sort after inserting
const typeOrder = {
  Booking: 1,
  Payment: 2,
  "Auto Settlement": 3,
};

return result.sort((a, b) => {
  //  First group by BookingCode
  if (a.BookingCode !== b.BookingCode) {
    return a.BookingCode.localeCompare(b.BookingCode);
  }

  //  Then enforce type order FIRST (most important)
  if (typeOrder[a.Type] !== typeOrder[b.Type]) {
    return typeOrder[a.Type] - typeOrder[b.Type];
  }

  //  Then sort by date
  return new Date(a.Date) - new Date(b.Date);
});
};

const addRunningBalance = (data) => {
  const balanceMap = {};

  return data.map((item) => {
    const code = item.BookingCode;

    if (!balanceMap[code]) balanceMap[code] = 0;

    balanceMap[code] += item.Debit - item.Credit;

    return {
      ...item,
      Balance: balanceMap[code],
    };
  });
};

  //  BALANCE
 const getBalance = (index) => {
  let bal = 0;
  const currentBooking = filtered[index].BookingCode;

  for (let i = 0; i <= index; i++) {
    if (filtered[i].BookingCode === currentBooking) {
      bal += filtered[i].Debit - filtered[i].Credit;
    }
  }

  return bal;
};

  //  PAGINATION
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paginated = filtered.slice(
    (page - 1) * PAGE_SIZE,
    page * PAGE_SIZE
  );

  //  EXPORT
 const exportExcel = () => {
  const rows = filtered.map((item) => ({
    Date: new Date(item.Date).toLocaleDateString(),
    Customer: item.FullName,
    Mobile: item.Mobile,
    Booking: item.BookingCode,
    Type: item.Type,
    Debit: item.Debit,
    Credit: item.Credit,
    Balance: item.Balance, // correct
  }));

  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Ledger");

  const buffer = XLSX.write(wb, {
    bookType: "xlsx",
    type: "array",
  });

  saveAs(new Blob([buffer]), "CustomerLedger.xlsx");
};

  const { startDate, endDate } = dateRange[0];

  return (
    <div className="max-w-7xl mx-auto bg-white shadow-2xl rounded-3xl p-8">

      <h2 className="text-3xl font-bold mb-6 text-center">
        Customer Ledger
      </h2>

      {/* FILTER BAR (same style as booking) */}
      <div className="bg-white shadow-xl rounded-2xl p-6 mb-8 relative">
        <h3 className="text-lg font-semibold text-gray-700 mb-4">
          Search & Filters
        </h3>

        <div className="grid md:grid-cols-3 gap-6 items-end">

  {/* Name */}
  <div className="flex flex-col">
    <label className="text-sm text-gray-600 mb-1">Customer Name</label>
    <div className="relative">
      <input
        type="text"
        placeholder="Enter name"
        className="px-4 py-2 border rounded-xl w-full focus:ring-2 focus:ring-emerald-500"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </div>
  </div>

  {/* Mobile */}
  <div className="flex flex-col">
    <label className="text-sm text-gray-600 mb-1">Mobile</label>
    <div className="relative">
      <input
        type="text"
        placeholder="Enter mobile"
        className="px-4 py-2 border rounded-xl w-full focus:ring-2 focus:ring-emerald-500"
        value={mobile}
        onChange={(e) => setMobile(e.target.value)}
      />
    </div>
  </div>

  {/* Date Range (same as before) */}
  <div className="flex flex-col relative">
    <label className="text-sm text-gray-600 mb-1">Date Range</label>

    <button
      onClick={() => {
        setTempRange(dateRange);
        setShowCalendar(!showCalendar);
      }}
      className="flex items-center gap-2 px-4 py-2 border rounded-xl"
    >
      <FaCalendarAlt className="text-gray-400" />
      {startDate && endDate
        ? `${startDate.toLocaleDateString()} - ${endDate.toLocaleDateString()}`
        : "Select date range"}
    </button>

            {showCalendar && (
              <div
                ref={calendarRef}
                className="absolute right-0 top-[110%] z-50 bg-white shadow-2xl rounded-xl p-4"
              >
                <DateRange
                  editableDateInputs
                  moveRangeOnFirstSelection={false}
                  ranges={tempRange}
                  onChange={(item) =>
                    setTempRange([item.selection])
                  }
                  rangeColors={["#10b981"]}
                />

                <div className="flex justify-between mt-3">
                  <button
                    onClick={() => {
                      setDateRange([
                        { startDate: null, endDate: null, key: "selection" },
                      ]);
                      setShowCalendar(false);
                    }}
                    className="px-3 py-1 border rounded-lg"
                  >
                    Default
                  </button>

                  <div className="flex gap-2">
                    <button
                      onClick={() => setShowCalendar(false)}
                      className="px-3 py-1 border rounded-lg"
                    >
                      Cancel
                    </button>

                    <button
                      onClick={() => {
                        setDateRange(tempRange);
                        setShowCalendar(false);
                      }}
                      className="px-3 py-1 bg-emerald-500 text-white rounded-lg"
                    >
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-4 p-3 bg-gray-50">

  {/* Left: Showing Entries */}
  <p className="text-sm text-gray-600">
    Showing 
    <span className="font-semibold text-gray-900 mx-1">
      {filtered.length}
    </span>
    of 
    <span className="font-semibold text-gray-900 mx-1">
      {data.length}
    </span>
    entries
  </p>

  {/* Right: Export */}
  <button
    onClick={exportExcel}
    className="flex items-center justify-center gap-2 bg-emerald-600 text-white px-4 py-2 rounded-lg shadow-sm hover:bg-emerald-700 active:scale-95 transition"
  >
    Export .xlxs
  </button>

</div>

      {/* TABLE */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-blue-600 to-emerald-500 text-white">
              <th className="p-3">Booking Date</th>
              <th>Customer</th>
              <th>Booking</th>
              <th>EventDate</th>
              <th>Debit</th>
              <th>Credit</th>
              <th>Balance</th>
            </tr>
          </thead>

          <tbody>
            {paginated.map((row, i) => {
              const index = (page - 1) * PAGE_SIZE + i;
              const bal = getBalance(index);

              return (
                <tr key={i} className="border-b hover:bg-emerald-50 text-center">
                  <td className="p-3">
                    {new Date(row.Date).toLocaleDateString('en-GB')}
                  </td>

                  <td>
                    {row.FullName}
                    <div className="text-xs text-gray-400">
                      {/* {row.Mobile} */}
                    </div>
                  </td>

                  <td>{row.BookingCode}</td>
                  <td>{new Date(row.EventDate).toLocaleDateString('en-GB')}</td>

                  <td className="text-red-600">{row.Debit || "-"}</td>
                  <td className="text-green-600">{row.Credit || "-"}</td>
                  <td className="font-semibold">{row.Balance}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PAGINATION */}
      <div className="flex justify-center mt-6 gap-4">
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="px-4 py-1 border rounded"
        >
          Prev
        </button>

        <span>
          Page {page} / {totalPages}
        </span>

        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          className="px-4 py-1 border rounded"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default CustomerLedger;